<template>
  <div class="container page bind-card-page">
    <van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#d7d7d7" @click="back" />
      </template>
    </van-nav-bar>

    <div class="main-box">
      <div class="label">{{ $t("setting.fill_bank_tip") }}</div>

      <van-cell-group>
        <van-field
          v-model="bank"
          :label="$t('setting.band_name')"
          readonly
          :placeholder="$t('setting.band_name_tip')"
          @click="showSelectBanks"
        />

        <!-- 只切换 bankid 和 bank_address，其他字段保持不变 -->
        <van-tabs v-model="accountType" type="card" class="account-type-tabs">
          <van-tab :title="$t('setting.bank_account')" name="bank">
            <van-field
              v-model.trim="bankid"
              :label="$t('setting.band_account')"
              :placeholder="$t('setting.band_account_tip')"
            >
              <template #button>
                <van-button
                  class="copy_btn"
                  type="primary"
                  @click.stop="copyToClipboard(bankid)"
                >
                  {{ $t("复制") }}
                </van-button>
              </template>
            </van-field>
          </van-tab>

          <van-tab :title="$t('setting.crypto_account')" name="crypto">
            <van-field
              v-model.trim="bank_address"
              :label="$t('setting.usdt_address')"
              :placeholder="$t('setting.usdt_address_tip')"
            >
              <template #button>
                <van-button
                  class="copy_btn"
                  type="primary"
                  @click.stop="copyToClipboard(bank_address)"
                >
                  {{ $t("复制") }}
                </van-button>
              </template>
            </van-field>
          </van-tab>
        </van-tabs>

        <van-field
          v-model.trim="username"
          :label="$t('setting.username')"
          :placeholder="$t('setting.username_place')"
          @paste="onPaste"
        />
      </van-cell-group>

      <p>{{ $t("setting.bank_warn") }}</p>
    </div>

    <van-button
      class="bindCard"
      :disabled="isDisabled"
      :loading="isDisabled"
      type="default"
      @click="bindCard"
    >
      {{ $t("setting.bank_ok") }}
    </van-button>

    <van-popup
      v-model="showBank"
      round
      position="bottom"
      :style="{ height: '35%' }"
    >
      <van-picker
        show-toolbar
        value-key="text"
        :confirm-button-text="$t('my.confirm')"
        :cancel-button-text="$t('my.cancel')"
        :columns="banks"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "BindCard",

  data() {
    return {
      banks: [],
      accountType: "bank",
      showBank: false,
      userInfo: {},
      bankid: "",
      bank_address: "",
      username: "",
      mobile: "",
      bank: "",
      bank_code: "",
      is_bind: false,
      isDisabled: false
    };
  },

  methods: {
    async copyToClipboard(value) {
      if (!value) {
        this.$toast(this.$t("common.nothing_to_copy"));
        return;
      }

      try {
        await navigator.clipboard.writeText(value);
        this.$toast(this.$t("common.copy_success"));
      } catch (err) {
        console.error("Failed to copy: ", err);
        this.$toast(this.$t("common.copy_failed"));
      }
    },

    onPaste(event) {
      event.preventDefault();
    },

    back() {
      return window.history.back();
    },

    bindCard() {
      if (this.userInfo.bankid || this.userInfo.bank_address || this.is_bind) {
        this.$toast(this.$t("setting.band_account_tip"));
        return false;
      }

      if (!this.bank) {
        this.$toast.fail(this.$t("setting.band_name_tip"));
        return false;
      }

      if (this.accountType === "bank" && !this.bankid) {
        this.$toast.fail(this.$t("setting.band_account_tip"));
        return false;
      }

      if (this.accountType === "crypto" && !this.bank_address) {
        this.$toast.fail(this.$t("setting.usdt_address_tip"));
        return false;
      }

      if (!this.username) {
        this.$toast(this.$t("setting.username_place"));
        return false;
      }

      if (this.isDisabled) return false;
      this.isDisabled = true;

      this.$http({
        method: "post",
        data: {
          bankid: this.accountType === "bank" ? this.bankid : "",
          bank: this.bank,
          bank_code: this.bank_code,
          bank_address: this.accountType === "crypto" ? this.bank_address : "",
          username: this.username,
          mobile: this.mobile
        },
        url: "user_set_bank"
      }).then(res => {
        if (res.code === 200) {
          this.$router.push({ path: "/Mine" });
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        this.isDisabled = false;
      });
    },

    showSelectBanks() {
      this.showBank = true;
    },

    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info"
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data || {};
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    getBankList() {
      this.$http({
        method: "get",
        url: "sys_get_banks"
      }).then(res => {
        if (res.code === 200) {
          this.banks = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    onConfirm(value) {
      this.bank = value.text;
      this.bank_code = value.value;
      this.showBank = false;
    },

    onCancel() {
      this.showBank = false;
    },

    getUserBankInfo() {
      this.$http({
        method: "get",
        url: "user_get_bank"
      }).then(res => {
        if (res.code === 200) {
          const data = res.data || {};
          this.is_bind = Boolean(data.is_bank || data.bank_address);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    disableCopyPaste() {
      const disableEvents = event => {
        event.preventDefault();
        event.stopPropagation();
      };

      this.disableEvents = disableEvents;
      document.addEventListener("contextmenu", disableEvents);
      document.addEventListener("copy", disableEvents);
    }
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
      return;
    }

    this.getUserInfo();
    this.getUserBankInfo();
    this.getBankList();
  },

  mounted() {
    this.disableCopyPaste();
  },

  beforeDestroy() {
    if (!this.disableEvents) return;
    document.removeEventListener("contextmenu", this.disableEvents);
    document.removeEventListener("copy", this.disableEvents);
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.container {
  min-height: 100vh;
  background: #f6f3f8;
}

.bind-card-page {
  box-sizing: border-box;
  padding-bottom: env(safe-area-inset-bottom);
}

.main-box {
  margin: 24px 24px 0;
  overflow: hidden;
  border-radius: 20px;
  background: #fff;

  .label {
    padding: 24px 30px;
    color: #666;
    font-size: 26px;
    line-height: 1.5;
  }

  p {
    margin: 0;
    padding: 24px 30px;
    color: #999;
    font-size: 24px;
    line-height: 1.5;
  }
}

.copy_btn {
  min-width: 100px;
  height: 54px;
  padding: 0 20px;
  border: none;
  border-radius: 28px;
  background: #d1af6f;
  font-size: 24px;
}

.bindCard {
  display: block;
  width: calc(100% - 60px);
  height: 80px;
  margin: 30px;
  border: none;
  border-radius: 50px;
  background: linear-gradient(90deg, #d1af6f, #d1af6f);
  color: #fff;
  font-size: 30px;
  font-weight: 700;
}

/*
 * 当前项目按 750px 设计稿转换 vw。
 * Vant 默认样式基于 375px，下面使用双倍尺寸覆盖，避免转换后显示过小。
 */
::v-deep .nav-bar .van-nav-bar__content {
  height: 92px;
}

::v-deep .nav-bar .van-nav-bar__title {
  max-width: 70%;
  font-size: 32px;
  line-height: 92px;
}

::v-deep .nav-bar .van-nav-bar__left,
::v-deep .nav-bar .van-nav-bar__right {
  padding: 0 30px;
}

::v-deep .nav-bar .van-icon {
  font-size: 40px;
}

::v-deep .main-box .van-cell {
  padding: 26px 30px;
  font-size: 28px;
  line-height: 48px;
}

::v-deep .main-box .van-field__label {
  width: 210px;
  color: #333;
  font-size: 28px;
}

::v-deep .main-box .van-field__body {
  min-height: 56px;
}

::v-deep .main-box .van-field__control {
  font-size: 28px;
  line-height: 48px;
}

::v-deep .main-box .van-field__button {
  padding-left: 20px;
}

::v-deep .account-type-tabs .van-tabs__nav--card {
  height: 72px;
  margin: 20px 30px;
  overflow: hidden;
  border-color: #d1af6f;
  border-radius: 36px;
}

::v-deep .account-type-tabs .van-tab {
  border-color: #d1af6f;
  color: #d1af6f;
  font-size: 28px;
  line-height: 68px;
}

::v-deep .account-type-tabs .van-tab.van-tab--active {
  background: linear-gradient(90deg, #d1af6f, #d1af6f);
  color: #fff;
}

::v-deep .account-type-tabs .van-tabs__content {
  padding-top: 8px;
}

::v-deep .van-picker__toolbar {
  height: 88px;
}

::v-deep .van-picker__title,
::v-deep .van-picker__confirm,
::v-deep .van-picker__cancel {
  font-size: 30px;
  line-height: 88px;
}

::v-deep .van-picker-column__item {
  font-size: 30px;
}

::v-deep .van-tabs--card>.van-tabs__wrap{
  height: auto;
}
</style>
